/**
 * Checks whether or not it's production environment
 *
 * @returns {boolean}
 */
export const isProduction = () => process.env.NODE_ENV === 'production';

/**
 * Checks whether or not it's development environment
 *
 * @returns {boolean}
 */
export const isDevelopment = () => process.env.NODE_ENV === 'development';
